import { useSearchParams } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useSpaces, useThreads } from "@/api/hooks";
import { PageHeader, EmptyState, ErrorState } from "@/components/States";
import { ThreadCard } from "@/components/ThreadCard";
import { PageSkeleton } from "@/components/ui/skeleton";

export default function ThreadsPage() {
  const [params, setParams] = useSearchParams();
  const space = params.get("space") ?? "";
  const threads = useThreads(space || undefined);
  const spaces = useSpaces();

  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader
        title="Threads"
        description="Every conversation that wrote notes, newest first."
        actions={
          spaces.data && spaces.data.length > 1 ? (
            <select
              value={space}
              onChange={(e) => setParams(e.target.value ? { space: e.target.value } : {})}
              className="h-8 rounded-md border bg-card px-2 text-sm"
              aria-label="Filter by space"
            >
              <option value="">All spaces</option>
              {spaces.data.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          ) : null
        }
      />
      {threads.isLoading && <PageSkeleton />}
      {threads.isError && <ErrorState error={threads.error} retry={() => threads.refetch()} />}
      {threads.data && threads.data.length === 0 && (
        <EmptyState icon={MessageSquare} title="No threads yet" description="A thread is created the first time a client writes without passing one." />
      )}
      {threads.data && threads.data.length > 0 && (
        <div className="flex flex-col">
          {threads.data.map((t) => (
            <ThreadCard key={t.id} thread={t} />
          ))}
        </div>
      )}
    </div>
  );
}
